import {AbstractDTO} from "./abstract";
import {IHomePageBanners} from "@signature-it/ngx-generic/interfaces";
/**
 * Created by shani on 11/09/17.
 */

export class HomepageBannersDTO extends AbstractDTO implements IHomePageBanners {

    id:number;
    location:string;
    title:string;
    link:string;
    icon:string;
    type:string;
    image_path: string;
    banner_class: string;
    banner_main_title: string;
    banner_secondary_title: string;


    constructor(attributes: Object, id: number, location: string, title: string, link: string, icon: string, type: string) {
        super(attributes);
        this.id = id;
        this.location = location;
        this.title = title;
        this.link = link;
        this.icon = icon;
        this.type = type;
    }
}
